import script from "./vip.vue?vue&type=script&setup=true&lang=ts"
export * from "./vip.vue?vue&type=script&setup=true&lang=ts"

import "./vip.vue?vue&type=style&index=0&id=e0d79754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0d79754"]])

export default __exports__